import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconWorld.c.svg?react';

export const IconWorld = withIconWrapper(ReactComponent);
